export type GscStringFloat = string;
export type GscDateTime = string;

export enum GscResponseCode {
  Ok = 200,
  NotFound = 404,
}
